import { useCallback, useEffect, useState } from "react"

const useSearch = () => {

    const [search, setSearch] = useState("")
    const [debounced, setDebounced] = useState("")

    useEffect(() => {

        const debounded_delay = setTimeout(() => {
            setDebounced(search)
        }, 1000)

        return () => clearTimeout(debounded_delay)

    }, [search])

    const onSearch = useCallback((e) => {
        setSearch(e?.target?.value)
    }, [search])

    return [search, debounced, onSearch]

}

export default useSearch